import React from 'react';
import SubHeader from '../../layout/components/SubHeader';

function Reports() {
    return (
        <div className="ecx-page ecx-page--full-width">
            <SubHeader
                title="Reports"
                description="Access clinic reports and downloadable summaries."
                icon="bi-file-earmark-bar-graph"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <div className="ecx-page-card ecx-page-panel">
                    <div className="ecx-page-empty py-5">
                        <span className="ecx-page-empty__icon">
                            <i className="bi bi-file-earmark-bar-graph" />
                        </span>
                        <h5 className="mb-2 text-dark">Reports coming soon</h5>
                        <p className="mb-0 text-muted">
                            This page will provide access to clinic reports and exports.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Reports;
